'use client'
import Image from 'next/image'
import { cn } from '@/lib/utils'
import { text12px, text16px, text32px } from '@/app/utils'
import { Button } from '@/registry/default/ui/button'
import React from 'react'
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/navigation'

export default function Computer() {
  const { status } = useSession()
  const router = useRouter()

  return (
    <div className={cn('bg-[#FFFFFF] text-foreground dark:text-background')}>
      <div className={cn('container py-12 flex space-x-10')}>
        <div
          className={cn(
            'flex flex-col w-[35%] items-start justify-center space-y-3'
          )}
        >
          <Image
            alt={'intro-two'}
            src={'/home/ai-transfer.svg'}
            width={141}
            height={152}
            className={cn('object-cover')}
          />
          <div>
            <div className={cn(text32px, 'text-[#121127] font-bold')}>
              管理业务全流程
            </div>
            <div className={cn(text32px, 'text-[#121127] font-bold')}>
              持续跟进用户满意度
            </div>
            <div className={cn(text32px, 'text-[#121127] font-bold')}>
              从意向到成交，全流程提升效率
            </div>
          </div>
          <div className={cn(text12px, 'text-[#7A7A86]')}>
            在拨业务日常调整频繁，一个新业务通常要经历十几次调整后才能趋于稳定，能够快捷的调整话术非常关键。我们提供
            AI
            电话员工话术维护功能，让你轻松应对业务调整，快速响应，实时变更，无培训与纠错成本；
          </div>
          <Button
            className={cn(
              text16px,
              'bg-[#444BD3] w-[124px] h-[52px] rounded-[6px]'
            )}
            onClick={() => {
              status === 'authenticated'
                ? router.push(`/dashboard`)
                : router.push('/register')
            }}
          >
            申请试用
          </Button>
        </div>
        <div className={cn('flex w-[65%] items-center justify-center')}>
          <Image
            alt={'intro-two'}
            src={'/home/computer.svg'}
            width={1008}
            height={591}
            className={cn('w-full object-cover transition-all')}
          />
        </div>
      </div>
    </div>
  )
}
